import { Component, Input } from '@angular/core';
import { NgbActiveModal }   from '@ng-bootstrap/ng-bootstrap';

import { VehicleRegistrationTireModel } from './typings/vehicle-registration.tire';

@Component({
  selector   : 'wor-vehicle-registration-tire-details',
  template: require('./vehicle-registration.tire-details.component.html')
})
export class VehicleRegistrationTireDetailsComponent {
  @Input() tire: VehicleRegistrationTireModel;

  constructor (
    public  activeModal: NgbActiveModal
  ) {}
}
